<template>
  <RouterLink
    v-if="to"
    :to="to"
    :title="title"
    :class="classObject" class="tag-item"
  >
    <slot />
  </RouterLink>
  <a
    v-else
    :href="href"
    :class="classObject"
    class="tag-item"
    @click="$emit('click')"
  >
    <slot />
  </a>
</template>

<script>
export default {
  name: 'TagItem',
  props: {
    to: {
      type: Object,
      default: () => {}
    },
    href: {
      type: String,
      default: '#'
    },
    title: {
      type: String,
      default: ''
    },
    active: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    default: {
      type: Boolean,
      default: true
    },
    large: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      classObject: {
        active: this.active,
        default: !this.large,
        large: this.large,
        disabled: this.disabled
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.tag-item {
  line-height: 1.6;
  background-color: $grey-f3;
  border-radius: 30px;
  display: inline-block;
  position: relative;
  text-align: center;
  text-decoration: none;
  transition: background-color .2s ease, color .2s ease;
  &.default {
    color: $grey-9b;
    padding: 8px 24px;
    margin: 0 10px 10px 0;
    font-size: 16px;
    font-weight: 700;
  }
  &.large {
    color: $grey-7d;
    padding: 8px 34px;
    margin: 0 16px 16px 0;
    font-size: 20px;
    font-weight: 500;
  }
  &.active {
    background-color: $theme-yellow;
    color: #ffffff;
  }
  &.disabled {
    cursor: not-allowed;
  }
}

@media only screen and (min-width: 1440px) {}
@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {}
@media only screen and (min-width: 768px) and (max-width: 1023.98px) {}
@media only screen and (max-width: 767.98px) {
  .tag-item {
    &.default {
      font-size: 14px;
      margin: 0 8px 8px 0;
    }
    &.large {
      color: $grey-9b;
      padding: 8px 24px;
      margin: 3px 8px 3px 0;
      font-size: 14px;
    }
  }
}
</style>
